import React, { useState, useEffect } from "react";
import { Header } from "../../../components/page-header/Header";
import { HiTrash } from "react-icons/hi2";
import { useCreateUpdateSlahTimeMutation, useGetSlahtimeQuery } from "../../../store/Reducer/prayertimes";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";




const PrayerTimeSpecial = () => {
  const { t } = useTranslation();

  const breadcrumbItems = [
    { label: t("universal_dashboard_text"), to: '/user-dashboard' },
    { label: t("prayerTimes_breadcrumb_title"), to: "/user-dashboard/prayer-times/main" },
    { label: t("salah_breadcrumb_title") },
  ];

  const [formValues, setFormValues] = useState({
    imsak: "",
    zawal: "",
    ishraq: "",
    taraweeh: "",
    eidNamaz: [""],
  });

  const [createUpdateSlahTime, { isLoading: saving }] =
    useCreateUpdateSlahTimeMutation();
  const {
    data: fetchedSalahTimes,
    isLoading: fetching,
    error,
  } = useGetSlahtimeQuery();

  // Prefill the form with fetched data

console.log('fetchedSalahTimes',fetchedSalahTimes)

  useEffect(() => {
    if (fetchedSalahTimes) {
      setFormValues({
        imsak: fetchedSalahTimes.data.imsak || "",
        zawal: fetchedSalahTimes.data.zawal || "",
        ishraq: fetchedSalahTimes.data.ishraq || "",
        taraweeh: fetchedSalahTimes.data.taraweeh || "",
        eidNamaz: fetchedSalahTimes.data.eidNamaz || [""],
      });
    }
  }, [fetchedSalahTimes]);

  const handleInputChange = (field, value) => {
    setFormValues((prev) => ({ ...prev, [field]: value }));
  };

  const handleEidChange = (index, value) => {
    setFormValues((prev) => ({
      ...prev,
      eidNamaz: prev.eidNamaz.map((time, i) => (i === index ? value : time)),
    }));
  };

  const addEidTime = () => {
    setFormValues((prev) => ({
      ...prev,
      eidNamaz: [...prev.eidNamaz, ""],
    }));
  };

  const deleteEidTime = (index) => {
    setFormValues((prev) => ({
      ...prev,
      eidNamaz: prev.eidNamaz.filter((_, i) => i !== index),
    }));
  };

  const handleSaveChanges = async () => {
    const payload = {
      imsak: parseInt(formValues.imsak, 10) || 0,
      zawal: parseInt(formValues.zawal, 10) || 0,
      ishraq: parseInt(formValues.ishraq, 10) || 0,
      taraweeh: parseInt(formValues.taraweeh, 10) || 0,
      eidNamaz: formValues.eidNamaz,
    };

    try {
      await createUpdateSlahTime(payload).unwrap();
      toast.success("Salah times updated successfully!");
    } catch (err) {
      toast.error(`Failed to update: ${err?.data?.message || err.message}`);
    }
  };

  return (
    <section className="min-h-screen bg-gradient-to-b from-slate-50 to-gray-50 font-sans">
      <div className="max-w-7xl mx-auto p-6">
        <div className="space-y-6">
          <div className="flex items-center justify-between">
            <Header title={t("salah_title")} breadcrumbItems={breadcrumbItems} />
          </div>

          <div className="content grid gap-6 md:grid-cols-2">
            <div className="col-span-2 grid gap-6 grid-cols-1 md:grid-cols-3">
              {/* Prayer Time Adjustments */}
              <div className="col-span-2 bg-white p-6 rounded-xl shadow-md">
                <h2 className="text-xl font-semibold mb-4">
                  {t("salah_prayer_time_title")}
                </h2>
                <div className="grid gap-6 md:grid-cols-2">
                  {["imsak", "ishraq", "zawal"].map((field) => (
                    <div className="space-y-2" key={field}>
                      <label
                        htmlFor={field}
                        className="block text-sm font-medium text-gray-700"
                      >
                        {field.charAt(0).toUpperCase() + field.slice(1)}
                      </label>
                      <div className="flex items-center gap-2">
                        <input
                          id={field}
                          type="number"
                          placeholder="Minutes"
                          value={formValues[field]}
                          onChange={(e) =>
                            handleInputChange(field, e.target.value)
                          }
                          className="w-32 px-3 py-2 border border-gray-300 rounded-md"
                        />
                        <span className="text-sm text-gray-500 whitespace-nowrap">
                          {field === "imsak"
                            ? "minutes before Fajr"
                            : field === "ishraq"
                              ? "minutes after Sunrise"
                              : "minutes before Zuhr"}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Ramadan and Eid Settings */}
              <div className="bg-white p-6 rounded-xl shadow-md">
                <h2 className="text-xl font-semibold mb-4">{t("salah_ramadan_settings_title")}</h2>
                <div className="space-y-2">
                  <label
                    htmlFor="taraweeh"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Taraweeh
                  </label>
                  <div className="flex items-center gap-2">
                    <input
                      id="taraweeh"
                      type="number"
                      placeholder="Minutes"
                      value={formValues.taraweeh}
                      onChange={(e) =>
                        handleInputChange("taraweeh", e.target.value)
                      }
                      className="w-28 px-3 py-2 border border-gray-300 rounded-md"
                    />
                    <span className="text-sm text-gray-500 whitespace-nowrap">
                      minutes after Isha
                    </span>
                  </div>
                </div>

                <h2 className="mt-6 mb-3 text-xl font-semibold">{t("salah_eid_prayers_title")}</h2>
                <div className="space-y-2">
                  {formValues.eidNamaz.map((time, index) => (
                    <div key={index} className="p-2 mb-2 border rounded-lg">
                      <div className="pr-2 flex items-center gap-4 mt-2">
                        <input
                          type="time"
                          value={time}
                          onChange={(e) => handleEidChange(index, e.target.value)}
                          className="w-28 px-3 py-2 border border-gray-300 rounded-md"
                        />
                        <span className="text-sm text-gray-500">Salah Time</span>
                      </div>
                      {formValues.eidNamaz.length > 1 && (
                        <button
                          onClick={() => deleteEidTime(index)}
                          className="mt-2 text-sm text-red-600 flex items-center gap-1"
                        >
                          <HiTrash size={18} /> Delete
                        </button>
                      )}
                    </div>
                  ))}
                  <button
                    onClick={addEidTime}
                    className="px-3 py-2 text-sm text-blue-600 border border-blue-600 rounded-lg hover:bg-blue-100"
                  >
                    {t("salah_add_more_btn_text")}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-6 flex justify-end items-center">
            <button
              onClick={handleSaveChanges}
              className="py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700"
              disabled={saving}
            >
              {saving ? t("universal_saving_text") : t("universal_save_changes_text")}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrayerTimeSpecial;
